export const defaultConfig = {
  hangersCount: 21,
  startValue: -10,
  step: 1,

  showMast: true,
  showSumaDistancias: false,
  mastMode: "fixed",
  challengeMode: false,

  // Estadísticas
  showStats: false,

  // básicas
  showMean: false,

  // nuevas
  showMedian: false,
  showMode: false,
  showRange: false,
  showVariance: false,
  showStdDev: false,
  showCoefVar: false,

  // avanzadas
  showDispersion: false
};